import { render, staticRenderFns } from "./common-text.vue?vue&type=template&id=a84740f6"
import script from "./common-text.vue?vue&type=script&lang=js"
export * from "./common-text.vue?vue&type=script&lang=js"
import style0 from "./common-text.vue?vue&type=style&index=0&id=a84740f6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a84740f6')) {
      api.createRecord('a84740f6', component.options)
    } else {
      api.reload('a84740f6', component.options)
    }
    module.hot.accept("./common-text.vue?vue&type=template&id=a84740f6", function () {
      api.rerender('a84740f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/iframe-page/components/common-text.vue"
export default component.exports